/**
 * The mandatory-deletion-reason rule, in one place.
 *
 * Six artifacts (workspace, project, workflow, connector, agent, knowledge
 * base) all require a reason before they can be deleted. The wording and the
 * definition of "empty" live here so the six dialogs cannot drift into saying
 * six different things about the same rule.
 *
 * This is convenience, not enforcement — the API rejects a blank reason on its
 * own (core/delete_reason.py). Validating here just means the user finds out
 * before the round-trip instead of after it.
 */

/** Shown under the field when it is blank. Matches the API's 400 detail. */
export const DELETE_REASON_REQUIRED = 'A reason for deletion is required.';

/**
 * Returns an error message, or null when the reason is acceptable.
 *
 * Whitespace-only counts as empty: "   " records nothing but would pass a
 * plain truthiness check, which is the loophole the rule exists to close.
 */
export function validateDeleteReason(reason: string | null | undefined): string | null {
  return (reason ?? '').trim() ? null : DELETE_REASON_REQUIRED;
}

/** True when the reason is good enough to submit. */
export function isDeleteReasonValid(reason: string | null | undefined): boolean {
  return validateDeleteReason(reason) === null;
}
